import format from 'date-fns/format'
import formatDistanceToNow from "date-fns/formatDistanceToNow"
import {zhCN} from "date-fns/locale"


export const parseDate = _parseDate
export const parseTime = _parseTime
export const formatDateTime = _formatDateTime
export const formatDateTimeToNow = _formatDateTimeToNow
export const formatFieldsForFlow = _formatFieldsForFlow

const DATE_TIME_FORMATS = {
    local: 'yyyy-MM', // 2018-05
    rung: 'yyyy-MM-dd', // 2018-05-16
    chinese: 'yyyy年MM月dd日', // 2018年05月16日
    slash: 'yyyy/MM/dd', // 2018/05/16
    greenwich: 'MMM dd, yyyy', // May 16, 2018
    rungDateTime: 'yyyy-MM-dd HH:mm:ss', // 2018-05-16 12:03:06
    rungDateNoSecond: 'yyyy-MM-dd HH:mm', // 2018-05-16 12:03
    chineseDateTime: 'yyyy年MM月dd日 HH时mm分ss秒', // 2018年05月16日 12时03分09秒
    chineseDateNoSecond: 'yyyy年MM月dd日 HH时mm分', // 2018年05月16日 12时03分
    slashDateTime: 'yyyy/MM/dd HH:mm:ss', // 2018/05/16 12:03:11
    slashDateNoSecond: 'yyyy/MM/dd HH:mm', // 2018/05/16 12:03
    greenwichDateTime: 'MMM dd, yyyy HH:mm:ss', // May 16, 2018 12:03:13
    greenwichDateNoSecond: 'MMM dd, yyyy HH:mm', // May 16, 2018 12:03
    timeWithSecond: 'HH:mm:ss', //12:03:13
    timeNoSecond: 'HH:mm',//12:03
}

function _formatFieldsForFlow(fields) {
    if (!fields) return fields
    if (typeof fields === 'string') fields = JSON.parse(fields)

    if (Array.isArray(fields)) {
        fields = fields.map(function (item) {
            // showStyle属性存在，且值不为空时，执行日期格式化
            if (item.attributes && item.attributes.showStyle
                && item.attributes.showStyle != 'timeWithSecond' && item.attributes.showStyle != 'timeNoSecond'
                && DATE_TIME_FORMATS[item.attributes.showStyle] && item.value)
                item.value = _formatDateTime(item.value, DATE_TIME_FORMATS[item.attributes.showStyle])
            return item
        })
    }

    return fields
}

function _formatDateTime(dateTime, dateTimeFormat) {
    if (!dateTime) return ''

    if (typeof dateTime == 'string') dateTime = _parseDate(dateTime)
    if (!dateTimeFormat) dateTimeFormat = 'yyyy-MM-dd HH:mm'
    return format(dateTime, dateTimeFormat)
}

function _formatDateTimeToNow(dateTime) {
    if (!dateTime) return ''
    if (typeof dateTime == 'string') dateTime = _parseDate(dateTime)
    return dateTime ? formatDistanceToNow(dateTime, {locale: zhCN}) : ''
}

function _parseDate(s, ignoreTimezone) {
    try {
        var d = eval(s);
        if (d && d.getFullYear) return d
    } catch (ex) {
    }
    if (typeof s == "object") return isNaN(s) ? null : s;
    if (typeof s == "number") {
        d = new Date(s * 1000);
        //if (d[oolO0]() != s) return null; //by sth 不知道这句是干什么，报错 oolO0 is not defined
        return isNaN(d) ? null : d
    }
    if (typeof s == "string") {
        var m = s.match(/^([0-9]{4})([0-9]{2})([0-9]{2})$/);
        if (m) {
            var date = new Date(m[1], m[2] - 1, m[3]);
            return date
        }
        m = s.match(/^([0-9]{4}).([0-9]*)$/);
        if (m) {
            date = new Date(m[1], m[2] - 1);
            return date
        }
        if (s.match(/^\d+(\.\d+)?$/)) {
            d = new Date(parseFloat(s) * 1000);
            //if (d[oolO0]() != s) return null; else //by sth 不知道这句是干什么，报错 oolO0 is not defined
            return d
        }
        if (ignoreTimezone === undefined) ignoreTimezone = true;
        d = _parseISO8601(s, ignoreTimezone) || (s ? new Date(s) : null);
        return isNaN(d) ? null : d
    }
    return null
}

function _parseISO8601(D, $) {
    var _ = D.match(/^([0-9]{4})([-\/]([0-9]{1,2})([-\/]([0-9]{1,2})([T ]([0-9]{1,2}):([0-9]{1,2})(:([0-9]{1,2})(\.([0-9]+))?)?(Z|(([-+])([0-9]{2})(:?([0-9]{2}))?))?)?)?)?$/);
    if (!_) {
        _ = D.match(/^([0-9]{4})[-\/]([0-9]{2})[-\/]([0-9]{2})[T ]([0-9]{1,2})/);
        if (_) {
            var A = new Date(_[1], _[2] - 1, _[3], _[4]);
            return A
        }
        _ = D.match(/^([0-9]{4}).([0-9]*)/);
        if (_) {
            A = new Date(_[1], _[2] - 1);
            return A
        }
        _ = D.match(/^([0-9]{4}).([0-9]*).([0-9]*)/);
        if (_) {
            A = new Date(_[1], _[2] - 1, _[3]);
            return A
        }
        _ = D.match(/^([0-9]{2})-([0-9]{2})-([0-9]{4})$/);
        if (!_) return null; else {
            A = new Date(_[3], _[1] - 1, _[2]);
            return A
        }
    }
    A = new Date(_[1], 0, 1);
    if ($ || !_[14]) {
        var C = new Date(_[1], 0, 1, 9, 0);
        if (_[3]) {
            A.setMonth(_[3] - 1);
            C.setMonth(_[3] - 1)
        }
        if (_[5]) {
            A.setDate(_[5]);
            C.setDate(_[5])
        }
        _fixDate(A, C);
        if (_[7]) A.setHours(_[7]);
        if (_[8]) A.setMinutes(_[8]);
        if (_[10]) A.setSeconds(_[10]);
        if (_[12]) A.setMilliseconds(Number("0." + _[12]) * 1000);
        _fixDate(A, C)
    } else {
        A.setUTCFullYear(_[1], _[3] ? _[3] - 1 : 0, _[5] || 1);
        A.setUTCHours(_[7] || 0, _[8] || 0, _[10] || 0, _[12] ? Number("0." + _[12]) * 1000 : 0);
        var B = Number(_[16]) * 60 + (_[18] ? Number(_[18]) : 0);
        B *= _[15] == "-" ? 1 : -1;
        A = new Date(+A + (B * 60 * 1000))
    }
    return A
}

function _parseTime(E, F) {
    if (!E) return null;
    var B = parseInt(E);
    if (B == E && F) {
        $ = new Date(0);
        if (F[0] == "H") $.setHours(B); else if (F[0] == "m") $.setMinutes(B); else if (F[0] == "s") $.setSeconds(B);
        if (isNaN($)) $ = null;
        return $
    }
    var $ = _parseDate(E);
    if (!$) {
        var D = E.split(":"), _ = parseInt(parseFloat(D[0])), C = parseInt(parseFloat(D[1])),
            A = parseInt(parseFloat(D[2]));
        if (!isNaN(_) && !isNaN(C) && !isNaN(A)) {
            $ = new Date(0);
            $.setHours(_);
            $.setMinutes(C);
            $.setSeconds(A)
        }
        if (!isNaN(_) && (F == "H" || F == "HH")) {
            $ = new Date(0);
            $.setHours(_)
        } else if (!isNaN(_) && !isNaN(C) && (F == "H:mm" || F == "HH:mm")) {
            $ = new Date(0);
            $.setHours(_);
            $.setMinutes(C)
        } else if (!isNaN(_) && !isNaN(C) && F == "mm:ss") {
            $ = new Date(0);
            $.setMinutes(_);
            $.setSeconds(C)
        }
    }
    return $
}

function _fixDate($, _) {
    if (+$) while ($.getDate() != _.getDate()) $[o0101O](+$ + ($ < _ ? 1 : -1) * HOUR_MS)
}